import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ToastService,
  UmssConfirmDialogComponent,
  UmssFeedbackButtonComponent
} from '@umss/shared/ui';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    UmssConfirmDialogComponent,
    UmssFeedbackButtonComponent
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'contractor';
  readonly feedbackUrl =
    'https://forms.clickup.com/90131860392/f/2ky4e2x8-2233/95XUYGNQ13MHKEZMYB';

  constructor(
    private toastService: ToastService,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.toastService.registerContainer(this.vcr);
  }
}
